<template>
    <div class="detail" :class="{ 'aniDetail_transition' : activeTransition }">
        <!-- background image -->
        <div class="img z-0 w-full h-full inset-0 absolute">
            <img class="w-full h-full" :src="'/showroom/media/products/' + $route.params.name + '.jpg'" />
        </div>
        <!-- content -->
        <div class="z-10 relative w-full h-full" :class="{ 'aniDetail_buttonsIn' : activeAnimation }">
            <button @click="goBack()" class="btn btn-green btn-small btn-home opacity-0" :class="{ 'opacity-100' : activeHelper}">{{ $t('selection-back') }}</button>
            <div class="container mx-auto flex px-8 xl:px-20 items-center h-full" :class="{ 'justify-start' : product.align === 'left', 'justify-end' : product.align === 'right' }">
                <div class="outer-card ">
                    <div class="navigation mb-3 flex align-center justify-between opacity-0" :class="{ 'opacity-100' : activeHelper}">
                        <button class="btn btn-small btn-secondary" :disabled="activeTransition" @click="goPrevious()"><font-awesome-icon :icon="['fal', 'long-arrow-left']" /> {{ translatedPrevious }}</button>
                        <button class="btn btn-small btn-secondary" :disabled="activeTransition" @click="goNext()">{{ translatedNext }} <font-awesome-icon :icon="['fal', 'long-arrow-right']" /></button>
                    </div>
                    <div class="card opacity-0" :class="{ 'opacity-100' : activeHelper}">
                        <div class="header">{{ $t('products.' + category + '.' + jsonName + '.name') }}</div>
                        <div class="text">
                            <span v-html="$t('products.' + category + '.' + jsonName + '.text')"></span>
                            <span class="block pt-4">
                                <span class="block bullet-point" v-for="advantage in $t('products.' + category + '.' + jsonName + '.advantages')" :key="advantage">{{advantage}}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import products from '../products';

export default {
    name: 'Detail',
    data() {
        return {
            product: null,
            jsonName: null,
            category: null,
            previous: null,
            next: null,
            // anoimation stuff
            activeAnimation: false,
            activeHelper: false,
            activeTransition: false,
        }
    },

    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    computed: {
        translatedNext() {
            return this.$t('products.' + this.category + '.' + this.next + '.name');
        },
        translatedPrevious() {
            return this.$t('products.' + this.category + '.' + this.previous + '.name');
        }
    },
    methods: {
        goBack() {
            this.$router.push({ path: '/' + this.category, query: { lang: this.$i18n.locale }});
        },
        goNext() {
            this.activeHelper = true;
            setTimeout(() => {
                this.activeAnimation = false;
                this.activeTransition = true;
            },1);
            setTimeout(() => {
                this.$router.push({ path: ('/' + this.category + '/' + this.next), query: { lang: this.$i18n.locale }})
                this.init();
            }, 500);
            setTimeout(() => {
                this.activeTransition = false;
            }, 1000)

        },
        goPrevious() {
            this.activeHelper = true;
            setTimeout(() => {
                this.activeAnimation = false;
                this.activeTransition = true;
            },1);
            setTimeout(() => {
                this.$router.push({ path: ('/' + this.category + '/' + this.previous), query: { lang: this.$i18n.locale }})
                this.init();
            }, 500);
            setTimeout(() => {
                this.activeTransition = false;
            }, 1000)
        },
        init() {
            // defocus
            document.activeElement.blur();
            // get route and item
            let name = this.$route.params.name;
            this.jsonName = name;
            let category = this.$route.params.category;
            this.category = category;
            this.product = products[category][name];
            // get previous and next item
            let i = Object.keys(products[category]).indexOf(name);
            var len = Object.keys(products[category]).length;
            this.previous = Object.keys(products[category])[(i+len-1)%len];
            this.next = Object.keys(products[category])[(i+1)%len];
            console.log(this.next)
        }
    },
    created() {
        this.init();
    },
    mounted() {
        this.$i18n.locale = this.$route.query.lang;
        setTimeout(() => {
            this.activeAnimation = true;
        }, 1000)
    }
}
</script>

<style lang="scss">
.img-prev {
    position: absolute;
    right: 100%;
    top: 0;
}
.img-next {
    position: absolute;
    left: 100%;
    top: 0;
}

.aniDetail_buttonsIn .btn {
    animation: fadeIn100 0.3s ease forwards;
}
.aniDetail_buttonsIn .card {
    animation: fadeIn100 0.3s ease forwards;
}
.aniDetail_buttonsIn .navigation {
    animation: fadeIn100 0.3s ease forwards;
}
.aniDetail_transition .card {
    animation: transitionCard 1s ease forwards;
}
.aniDetail_transition .navigation {
    animation: transitionCard 1s ease forwards;
}
.aniDetail_transition .img {
    animation: transitionImg 1s linear forwards;
}
@keyframes transitionCard {
    0% { opacity: 1; }
    50% { opacity: 0; }
    100% { opacity: 1; }
}
@keyframes transitionImg {
    0% { filter: blur(0px); opacity: 1; }
    50% { filter: blur(50px); opacity: 0.5; }
    100% { filter: blur(0px); opacity: 1; }
}
</style>
